import { Button } from "@/components/ui/button";
import { DEMO_PATH, HOME_PATH, ROOT_PATH, SIGNIN_PATH } from "@/pages/paths";
import { isSignedInAtom } from "@/state/auth.state";
import { Trans } from "@lingui/react/macro";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const PAGE_CONTAINER_ID = "page-container";

export function AppTopNav() {
  const isSignedIn = useAtomValue(isSignedInAtom);
  const authKnown = isSignedIn !== undefined;
  const authed = isSignedIn === true;

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      setIsScrolled(target.scrollTop > 20);
    };

    const container = document.getElementById(PAGE_CONTAINER_ID);
    container?.addEventListener("scroll", handleScroll);

    return () => {
      container?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        isScrolled
          ? "bg-white/95 shadow-md backdrop-blur-sm dark:bg-gray-900/95"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <Link to={HOME_PATH} className="flex items-center gap-2">
            <img src="/logo.svg" alt="Stratistics logo" className="h-8 w-8" />
            <span className="text-2xl font-bold text-gray-900 dark:text-white">
              Stratistics
            </span>
          </Link>

          <nav className="hidden items-center gap-6 md:flex">
            <Link
              to={DEMO_PATH}
              className="text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
            >
              <Trans>Demo</Trans>
            </Link>

            {!authKnown ? (
              <Button variant="outline" size="sm" disabled>
                <Trans>Loading…</Trans>
              </Button>
            ) : authed ? (
              <Button asChild variant="outline" size="sm">
                <Link to={ROOT_PATH}>
                  <Trans>Dashboard</Trans>
                </Link>
              </Button>
            ) : (
              <Button asChild variant="outline" size="sm">
                <Link to={SIGNIN_PATH}>
                  <Trans>Sign In</Trans>
                </Link>
              </Button>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}
